<template lang="pug">
  section(id="footer")
     .goscontainer
          v-row
            v-col.py-4 2016-{{new Date().getFullYear()}} © ТЕХНОЛОГИЧЕСКИЕ ПРАВОВЫЕ СИСТЕМЫ
            v-col(cols="auto" v-if="cmsOn") 
              v-btn.mr-6.py-2.px-0(
                v-for="(item, i) in items"
                :key="item.title"
                text 
                color="#314369"
                @click="handleSelect(item)") {{ item.title }}

            
</template>

<script>
  export default {
    name: 'Sectionfooter',
    props: {
      cmsOn: {
          default:false,
          type:Boolean
      }
    },
    methods: {
      handleSelect (item) {
        if (item.action) 
          item.action()
      }
    },
    computed: {
      items () {
        let items = [
          { title: 'Внести средства на депозитный счет УСД', action: () => this.$router.push({ path: `/payment_order` })},
          { title:'Условия использования', action: () => this.$router.push({ path: `/page/sp_rules` }) },
          { title:'Ответы на вопросы', action: () => this.$router.push({ path: `/page/sp_faq` }) },
          { title:'Контакты', action: () => this.$router.push({ path: `/page/sp_help` }) }
        ]
        
        return items
      },
    },
  }
</script>

<style lang="sass" scoped>
  #footer
    padding: 50px 16px 40px 16px 
    background: #E0E3E9
    color: #314369 
    font-size: 14px
</style>
